import { emeraldRequest } from '../../../common/api/emerald-request';
import { AxiosRequestConfig } from 'axios';
import { EmeraldRequestParams } from '../../../common/interfaces/requests/EmeraldRequestParams';

interface ITenderSuggestedAmounts {
  suggestedAmounts: number[];
}

export const tenderSuggestedAmountLookup = async (
  transactionId: string,
  tenderId: string,
): Promise<number[]> => {
  const axiosConfig: AxiosRequestConfig = {
    url: `/transaction-management/transactions/${transactionId}/tenders/${tenderId}/suggested-amounts`,
    method: 'GET',
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: false,
    showLoggingInfo: true,
    spanOptions: { name: 'Tender- Payment Options' },
  };

  const response = await emeraldRequest<ITenderSuggestedAmounts>(emeraldRequestParams);

  return response.suggestedAmounts;
};
